import { Option } from '@app/components/various/Fields/Select';
import { AutocompleteField, FormGrid } from '@app/components/various/Form';
import { getCurrencyAffix } from '@app/logic/price';
import { isEmpty } from '@app/utils/isEmpty';
import { Pricelist } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  fieldName: string;
  lookbookPricelist: Pricelist[];
  isLoading?: boolean;
}

export const LookbookSettingsPricelistField = ({ fieldName, isLoading = false, lookbookPricelist }: Props) => {
  const { t } = useTranslation(['common']);

  const hasSelectedPricelists = !isEmpty(lookbookPricelist);

  return (
    <FormGrid>
      <AutocompleteField
        name={fieldName}
        overflowContainer
        isLoadingOptions={isLoading}
        label={t('common:pricelist')}
        isRequired
        placeholder={hasSelectedPricelists ? '' : t('common:none')}
        showArrow={false}
        isDisabled
        isReadOnly
      >
        {lookbookPricelist.map(({ id, currency, name }) => {
          return (
            <Option key={id} value={id} description={getCurrencyAffix(currency)}>
              {name}
            </Option>
          );
        })}
      </AutocompleteField>
    </FormGrid>
  );
};
